import React from 'react'

import { BaseSafeFormView } from '@/components/base'
import { PullToRefresh } from '@/components'
import { DashboardHeader, DashboardContent } from '@/features/dashboard'
import { usePullToRefreshHandler } from '@/hooks'

export const DashboardScreen: React.FC = () => {
  const dashboardContentRef = React.useRef<{
    handleRefreshBalance: () => Promise<void>
  }>(null)

  const { isRefreshing, handlePullRefresh, handleRefresh } =
    usePullToRefreshHandler(async () => {
      if (dashboardContentRef.current?.handleRefreshBalance) {
        await dashboardContentRef.current.handleRefreshBalance()
      }
    })

  return (
    <PullToRefresh
      onRefresh={handlePullRefresh}
      isRefreshing={isRefreshing}
    >
      <div
        style={{
          paddingLeft: '13px',
          paddingRight: '13px',
          paddingBottom: '100px',
        }}
      >
        <DashboardHeader onRefresh={handleRefresh} />
        <DashboardContent ref={dashboardContentRef} />
      </div>
    </PullToRefresh>
  )
}
